import './styles/app.scss'
import MainRouter from './routers/main'

function App() {
  return <MainRouter />
}

export default App
